<template>
    <div>
        <div class="page-header">
            <h1 class="page-title">{{ $t("workers.title") }}</h1>

            <div>
                <a
                    href="#"
                    class="btn btn--primary"
                    @click.prevent="$router.push({ name: 'workers.create' })"
                >
                    {{ $t("workers.add") }}
                </a>
            </div>
        </div>

        <div class="filters">
            <div class="search">
                <img src="/svgs/search-icon.svg" alt="search-icon" />
                <input
                    class="search"
                    type="text"
                    :placeholder="$t('general.search') + '...'"
                    v-model="search"
                />
            </div>
        </div>

        <table class="table" ref="overviewTable">
            <thead>
                <tr>
                    <th class="small"></th>
                    <th>{{ $t("workers.first_name") }}</th>
                    <th>{{ $t("workers.last_name") }}</th>
                    <th>{{ $t("workers.function") }}</th>
                </tr>
            </thead>

            <draggable tag="tbody" v-model="filteredItems" handle=".handle">
                <router-link
                    :to="{ name: 'workers.edit', params: { id: item.id } }"
                    tag="tr"
                    v-for="item in filteredItems"
                    :key="item.id"
                >
                    <td>
                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="handle"
                             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="🔍-Product-Icons" stroke="none" stroke-width="1">
                                <g id="ic_fluent_drag_24_filled" fill="#002D4D">
                                    <path
                                        d="M12,16 C12.5128358,16 12.9355072,16.3860402 12.9932723,16.8833789 L13,17 L13,18.584 L13.2928932,18.2928932 C13.6533772,17.9324093 14.2206082,17.9046797 14.6128994,18.2097046 L14.7071068,18.2928932 C15.0675907,18.6533772 15.0953203,19.2206082 14.7902954,19.6128994 L14.7071068,19.7071068 L12.7071068,21.7071068 L12.663147,21.7485042 L12.663147,21.7485042 L12.5953066,21.8036654 L12.5953066,21.8036654 L12.4840621,21.8753288 L12.4840621,21.8753288 L12.371336,21.9287745 L12.371336,21.9287745 L12.265993,21.9641549 L12.265993,21.9641549 L12.1484669,21.9889822 L12.1484669,21.9889822 L12.0592517,21.9982539 L12.0592517,21.9982539 L11.9406155,21.9982539 L11.9406155,21.9982539 L11.881947,21.9930971 L11.881947,21.9930971 L11.7664859,21.9725773 L11.7664859,21.9725773 L11.6583335,21.9401054 L11.6583335,21.9401054 L11.5767785,21.9063266 L11.5767785,21.9063266 L11.4792912,21.8540045 L11.4792912,21.8540045 L11.3832499,21.787214 C11.3515341,21.7623312 11.3213595,21.7355731 11.2928932,21.7071068 L9.29289322,19.7071068 C8.90236893,19.3165825 8.90236893,18.6834175 9.29289322,18.2928932 C9.65337718,17.9324093 10.2206082,17.9046797 10.6128994,18.2097046 L10.7071068,18.2928932 L11,18.585 L11,17 C11,16.4871642 11.3860402,16.0644928 11.8833789,16.0067277 L12,16 Z M18.2928932,9.29289322 C18.6533772,8.93240926 19.2206082,8.90467972 19.6128994,9.20970461 L19.7071068,9.29289322 L21.7071068,11.2928932 L21.7485042,11.336853 L21.7485042,11.336853 L21.8036654,11.4046934 L21.8036654,11.4046934 L21.8753288,11.5159379 L21.8753288,11.5159379 L21.9287745,11.628664 L21.9287745,11.628664 L21.9641549,11.734007 L21.9641549,11.734007 L21.9889822,11.8515331 L21.9889822,11.8515331 L21.9982536,11.9407399 L21.9982536,11.9407399 L21.9982536,12.0592877 L21.9982536,12.0592877 L21.9931674,12.1174626 L21.9931674,12.1174626 L21.9725773,12.2335141 L21.9725773,12.2335141 L21.9401054,12.3416665 L21.9401054,12.3416665 L21.9063266,12.4232215 L21.9063266,12.4232215 L21.8540045,12.5207088 L21.8540045,12.5207088 L21.7803112,12.625449 L21.7803112,12.625449 L21.7071068,12.7071068 L19.7071068,14.7071068 C19.3165825,15.0976311 18.6834175,15.0976311 18.2928932,14.7071068 C17.9324093,14.3466228 17.9046797,13.7793918 18.2097046,13.3871006 L18.2928932,13.2928932 L18.584,13 L17,13 C16.4871642,13 16.0644928,12.6139598 16.0067277,12.1166211 L16,12 C16,11.4871642 16.3860402,11.0644928 16.8833789,11.0067277 L17,11 L18.585,11 L18.2928932,10.7071068 C17.9324093,10.3466228 17.9046797,9.77939176 18.2097046,9.38710056 L18.2928932,9.29289322 Z M4.29289322,9.29289322 C4.68341751,8.90236893 5.31658249,8.90236893 5.70710678,9.29289322 C6.06759074,9.65337718 6.09532028,10.2206082 5.79029539,10.6128994 L5.70710678,10.7071068 L5.414,11 L7,11 C7.51283584,11 7.93550716,11.3860402 7.99327227,11.8833789 L8,12 C8,12.5128358 7.61395981,12.9355072 7.11662113,12.9932723 L7,13 L5.415,13 L5.70710678,13.2928932 C6.06759074,13.6533772 6.09532028,14.2206082 5.79029539,14.6128994 L5.70710678,14.7071068 C5.34662282,15.0675907 4.77939176,15.0953203 4.38710056,14.7902954 L4.29289322,14.7071068 L2.29289322,12.7071068 L2.19633458,12.5953066 L2.19633458,12.5953066 L2.12467117,12.4840621 L2.12467117,12.4840621 L2.07122549,12.371336 L2.07122549,12.371336 L2.03584514,12.265993 L2.03584514,12.265993 L2.0110178,12.1484669 L2.0110178,12.1484669 L2.00361597,12.0852242 L2.00018018,11.980824 L2.00018018,11.980824 L2.00396641,11.9107499 L2.00396641,11.9107499 L2.02024007,11.7992742 L2.02024007,11.7992742 L2.04973809,11.6878575 L2.04973809,11.6878575 L2.09367336,11.5767785 L2.09367336,11.5767785 L2.14599545,11.4792912 L2.14599545,11.4792912 L2.21278596,11.3832499 C2.23766884,11.3515341 2.26442691,11.3213595 2.29289322,11.2928932 L4.29289322,9.29289322 Z M12,9.25 C13.5187831,9.25 14.75,10.4812169 14.75,12 C14.75,13.5187831 13.5187831,14.75 12,14.75 C10.4812169,14.75 9.25,13.5187831 9.25,12 C9.25,10.4812169 10.4812169,9.25 12,9.25 Z M11.8515331,2.0110178 L11.9248232,2.00278767 L11.9248232,2.00278767 L12.0543273,2.00146742 L12.0543273,2.00146742 L12.1747075,2.01528127 L12.1747075,2.01528127 L12.3121425,2.04973809 L12.3121425,2.04973809 L12.4232215,2.09367336 L12.4232215,2.09367336 L12.5207088,2.14599545 L12.5207088,2.14599545 L12.625449,2.21968877 L12.625449,2.21968877 L12.7071068,2.29289322 L14.7071068,4.29289322 C15.0976311,4.68341751 15.0976311,5.31658249 14.7071068,5.70710678 C14.3466228,6.06759074 13.7793918,6.09532028 13.3871006,5.79029539 L13.2928932,5.70710678 L13,5.415 L13,7 C13,7.51283584 12.6139598,7.93550716 12.1166211,7.99327227 L12,8 C11.4871642,8 11.0644928,7.61395981 11.0067277,7.11662113 L11,7 L11,5.414 L10.7071068,5.70710678 C10.3466228,6.06759074 9.77939176,6.09532028 9.38710056,5.79029539 L9.29289322,5.70710678 C8.93240926,5.34662282 8.90467972,4.77939176 9.20970461,4.38710056 L9.29289322,4.29289322 L11.2928932,2.29289322 L11.4046934,2.19633458 L11.4046934,2.19633458 L11.5159379,2.12467117 L11.5159379,2.12467117 L11.628664,2.07122549 L11.628664,2.07122549 L11.734007,2.03584514 L11.734007,2.03584514 L11.8515331,2.0110178 L11.8515331,2.0110178 Z"
                                        id="🎨-Color"></path>
                                </g>
                            </g>
                        </svg>
                    </td>
                    <td>{{ item.first_name }}</td>
                    <td>{{ item.last_name }}</td>
                    <td>{{ item.function }}</td>
                </router-link>
            </draggable>
        </table>
    </div>
</template>

<script>
    import WorkerService from "../../services/workers";
    import draggable from 'vuedraggable';

    export default {
        name: "workers",
        components: {
            draggable,
        },
        data() {
            return {
                items: [],
                search: "",
            };
        },
        computed: {
            filteredItems: {
                get() {
                    return this.items.filter((item) => {
                        return this.search
                            .toLowerCase()
                            .split(" ")
                            .every((search) =>
                                ["first_name", "last_name", "function"].some((field) =>
                                    item[field].toLowerCase().includes(search)
                                )
                            );
                    });
                },
                set(items) {
                    if (this.search == "") {
                        this.items = items.map((item, key) => ({ ...item, order: key }));
                        WorkerService.updateOrder({ workers: this.items }).then(_ => this.$flashMessage('Volgorde is gewijzigd', 3500, 'success'))
                            .catch(_ => this.$flashMessage('Er is iets misgegaan bij het opslaan', 3500, 'error'));
                    } else {
                        this.search = "";
                    }
                },
            },
        },
        async mounted() {
            this.items = (await WorkerService.index()).data.data;
        },
    };
</script>

<style lang="scss" scoped>
    table {
        td {
            svg {
                vertical-align : middle;
            }
        }
    }
</style>